var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRhythmGym(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 101.6,
    cy: 45.2,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1,133.7c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1v-54H59.1L59.1,133.7L59.1,133.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,24.7c-2-2-5.3-2-7.3,0c-2,2-2,5.3,0,7.3L54,73.7V59.1L19.5,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.1,59.3V12.9h-1.4c-3.2,0-4.7-1.1-6.4-2.3c-1.9-1.3-4-2.8-8-2.8c-4,0-6.1,1.5-8,2.8c-1.7,1.2-3.2,2.3-6.4,2.3 s-4.7-1.1-6.4-2.3c-1.9-1.3-3.9-2.8-8-2.8c-4,0-6.1,1.5-8,2.8c-1.7,1.2-3.2,2.3-6.4,2.3s-4.7-1.1-6.4-2.3c-1.9-1.3-3.9-2.8-8-2.8 c-4,0-6.1,1.5-8,2.8c-1.7,1.2-3.2,2.3-6.4,2.3c-3.2,0-4.7-1.1-6.4-2.3c-1.9-1.3-3.9-2.8-8-2.8c-4,0-6.1,1.5-8,2.8 c-1.7,1.2-3.2,2.3-6.4,2.3s-4.7-1.1-6.4-2.3c-1.9-1.3-3.9-2.8-8-2.8c0,0-0.1,0-0.1,0v2.7c0,0,0.1,0,0.1,0c3.2,0,4.7,1.1,6.4,2.3 c1.9,1.3,4,2.8,8,2.8s6.1-1.5,8-2.8c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3c1.9,1.3,4,2.8,8,2.8s6.1-1.5,8-2.8 c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3c1.9,1.3,4,2.8,8,2.8c4,0,6.1-1.5,8-2.8c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3 c1.9,1.3,4,2.8,8,2.8s6.1-1.5,8-2.8c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3c1.6,1.2,3.5,2.5,6.6,2.8v43.6H95.1L68.6,32.7 c-2-2-5.3-2-7.3,0c-2,2-2,5.3,0,7.3l19.2,19.2H59.2v18h32.1c2.3,0,4.6-0.9,6.4-2.6c1.4-1.4,2.3-3.2,2.5-5.1h29.5 c2.8,0,5.1-2.3,5.1-5.1C134.9,61.9,133.3,59.9,131.1,59.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRhythmGym);
export default __webpack_public_path__ + "static/media/rhythmGym.dbea6ac34a7d852265a31ec389189737.svg";
export { ForwardRef as ReactComponent };